import PropTypes from 'prop-types'

import { METADATA_TYPES } from '../constants'

const metadataTypePropType = PropTypes.oneOf([
  METADATA_TYPES.ALLERGENS.value,
  METADATA_TYPES.COURSE_TYPES.value,
  METADATA_TYPES.CUISINE_TYPES.value,
  METADATA_TYPES.DIETS.value,
  METADATA_TYPES.DISH_TYPES.value,
  METADATA_TYPES.INGREDIENTS.value,
  METADATA_TYPES.LOCATION_TYPES.value,
])

export default metadataTypePropType
